import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-pl",
  "use": "icon-flag-pl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-pl\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 0h1024v512H0z\" fill=\"#FFFFFF\" p-id=\"12208\" /><path d=\"M0 512h1024v512H0z\" fill=\"#D41D3B\" p-id=\"12209\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-pl.svg
// module id = Ztis
// module chunks = 24